import { useReduxState } from 'hooks';
import api from 'api';
import { ConfirmButton } from 'components/common';

interface Props {
  courseId: number;
  onUpdate: () => Promise<void>;
  userId: number;
}

const FollowUsersAllowNewAttempt = ({ courseId, onUpdate, userId }: Props) => {
  const { messages } = useReduxState();

  const handleNewAttempt = async () => {
    const response = await api.post(
      `/admin/courses/${courseId}/participants/${userId}/retry`
    );
    if (!response.data || !response.data.success) return false;

    await onUpdate();

    return true;
  };

  return (
    <ConfirmButton
      actionText={messages.completionsAllowNewAttempt}
      buttonText={messages.completionsAllowNewAttempt}
      buttonIcon="redo-alt"
      buttonIsDropdown={true}
      confirmText={messages.completionsAllowNewAttemptConfirm}
      confirmTitle={messages.completionsAllowNewAttempt}
      onConfirm={handleNewAttempt}
      successMessage={messages.completionsAllowNewAttemptSuccess}
      stopPropagation={true}
    />
  );
};

export default FollowUsersAllowNewAttempt;
